export class Country {

    constructor(readonly continentId: number, readonly name: string) {
    }
}



// WEBPACK FOOTER //
// ./src/api/request/Country.ts